import TypoGraphy from '@material-ui/core/Typography'
import styled     from 'styled-components'

export const Welcome = styled(TypoGraphy)`
  margin: ${({ theme }) => theme.spacing.unit * 10 }px 0;
`

export const LoginLayout = styled.div`
  display: flex;
  justify-content: center;
`



// WEBPACK FOOTER //
// ./src/components/templates/LoginLayout.ts